import { graphql, readInlineData } from "react-relay";

import { article as articleData } from "~/data";
import type { helpersArticleSections$key } from "~/queries/__generated__/helpersArticleSections.graphql";

export const checkIsPostiesArticle = (reference: helpersArticleSections$key) => {
  const article = readInlineData(
    graphql`
      fragment helpersArticleSections on Article @inline {
        sections {
          value {
            entityId
          }
        }
      }
    `,
    reference,
  );
  const sections = article?.sections?.flatMap(section =>
    section?.value?.map(value => value && value.entityId),
  );
  return sections?.includes(articleData.sections.posties);
};
